import { Fragment } from 'react';
import type { TimesheetHistoryItem } from '@sdk/timesheets/types/TimesheetHistory';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text12 from '@sdk/components/ui/typography/Text12';

import TimesheetHistoryActions from '@web/timeClock/TimesheetHistoryActions/TimesheetHistoryActions';
import { ScrollableContainer } from '@web/timeClock/TimesheetHistoryRows/timesheetHistoryRows.styles';

type Props = {
  timesheetHistoryItems: TimesheetHistoryItem[];
};

const TimesheetHistoryRows = ({ timesheetHistoryItems }: Props) => {
  return (
    <ScrollableContainer>
      {timesheetHistoryItems.map((historyItem: TimesheetHistoryItem, index: number) => {
        return (
          <Fragment key={index}>
            <Column pTop={20} pBottom={20} pLeft={20} pRight={20}>
              <Text14 themeColor={ThemeColorType.primary} mBottom={-5}>
                {historyItem.user.fullname}
              </Text14>
              <TimesheetHistoryActions historyItem={historyItem} />
              <Text12 themeColor={ThemeColorType.iconGray} mTop={5}>
                {historyItem.whenStr}
              </Text12>
            </Column>
            <HorizontalSeparator />
          </Fragment>
        );
      })}
    </ScrollableContainer>
  );
};

export default TimesheetHistoryRows;
